<template>
  <div class="page">
    <h1 class="pa-h3 text-center m-xl-b">Frequently Asked Questions</h1>
    <div v-for="topic of topics" class="topic p-sm-b">
      <h2>
        <a
          class="flex-row gap-xs pa-h3 pa-pink m-sm-b"
          href="#"
          @click.prevent="open[topic] = !open[topic]"
        >
          <span>{{ topic }}</span>
          <i v-if="!open[topic]" class="pi pi-chevron-right" />
          <i v-else class="pi pi-chevron-down" />
        </a>
      </h2>
      <div v-if="open[topic]" class="questions flex-column gap-sm">
        <div v-for="question of faqs.list.filter((i) => i.topic === topic)">
          <div class="question pa-pink">
            <b>{{ question.content }}</b>
          </div>
          <div class="answer" v-html="question.answer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFAQsStore } from "@/stores/faqs";
import { useHead } from "@unhead/vue";
import { computed, onMounted, ref } from "vue";

const faqs = useFAQsStore();

const open = ref<Record<string, boolean>>({});

const topics = computed(() => {
  return Array.from(new Set(faqs.list.map((i) => i.topic))).filter(
    (i) => i,
  ) as string[];
});

useHead({
  title: "Frequently Asked Questions",
  meta: [
    {
      name: "description",
      content:
        "Explore our FAQ page for quick answers to common Paparazzi Accessories questions and expert insights.",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://paparazziaccessories.com/faqs",
    },
  ],
});

onMounted(() => {
  faqs.sync();
});
</script>

<style scoped>
.page {
  max-width: 714px;
  font-size: 14px;
}

a {
  transition: all 0.4s ease;
  text-shadow: none;
}

a:hover {
  font-weight: 300;
  transition: all 0.5s;
  text-shadow: 0.25px 0 var(--Paparazzi-Pink, #ec008c);
}

.pi-chevron-right:before,
.pi-chevron-down:before {
  font-size: 10px;
}
.question.pa-pink b {
  font-weight: 500;
}

.answer :deep(a) {
  color: var(--Paparazzi-Pink, #ec008c);
}
.answer :deep(p:last-child) {
  margin-bottom: 0;
}
.answer :deep(li) {
  text-align: left;
  list-style: revert;
}
</style>
